/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./pit-page-footer.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./pit-page-footer.component";
var styles_PitPageFooterComponent = [i0.styles];
var RenderType_PitPageFooterComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_PitPageFooterComponent, data: {} });
export { RenderType_PitPageFooterComponent as RenderType_PitPageFooterComponent };
export function View_PitPageFooterComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 0, "div", [["class", "pit-page-footer__content"]], null, null, null, null, null))], null, null); }
export function View_PitPageFooterComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "pit-page-footer", [], null, null, null, View_PitPageFooterComponent_0, RenderType_PitPageFooterComponent)), i1.ɵdid(1, 114688, null, 0, i2.PitPageFooterComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var PitPageFooterComponentNgFactory = i1.ɵccf("pit-page-footer", i2.PitPageFooterComponent, View_PitPageFooterComponent_Host_0, {}, {}, []);
export { PitPageFooterComponentNgFactory as PitPageFooterComponentNgFactory };
